export default defineNuxtPlugin((nuxtApp) => {
    const route = useRoute()
    const requestURL = import.meta.server ? useRequestURL() : null

    const resolveOrigin = () => {
        if (import.meta.client) {
            return window.location.origin
        }

        return requestURL?.origin || ''
    }

    const buildCanonicalUrl = (pathname, pageParam = null) => {
        const pathParts = pathname
            .split('/')
            .filter(Boolean)
        const hasCategoryFilters = pathParts.some(part => part.includes('='))
        const basePathParts = pathParts.filter(part => !part.includes('='))
        const canonicalPath = basePathParts.length
            ? '/' + basePathParts.join('/') + '/'
            : '/'

        let canonicalUrl = resolveOrigin() + canonicalPath

        if (!hasCategoryFilters && pageParam) {
            canonicalUrl += `?page=${pageParam}`
        }

        return canonicalUrl
    }

    const updateCanonical = () => {
        const pathname = import.meta.client
            ? window.location.pathname
            : route.path
        const pageParam = import.meta.client
            ? new URLSearchParams(window.location.search).get('page')
            : (Array.isArray(route.query.page) ? route.query.page[0] : route.query.page) || null

        useHead({
            link: [
                {
                    key: 'canonical',
                    rel: 'canonical',
                    href: buildCanonicalUrl(pathname, pageParam),
                },
            ],
        })
    }

    // SSR + first paint — must be in initial HTML for crawlers
    updateCanonical()

    if (!import.meta.client) {
        return
    }

    const updateCategoryFilterRobots = (event) => {
        if (typeof event?.detail?.hasCategoryFilters !== 'boolean') {
            return
        }

        const searchParams = new URLSearchParams(window.location.search)
        const canIndex = useRuntimeConfig().public.APP_ENV === 'production'
            && !event.detail.hasCategoryFilters
            && !searchParams.get('search')
            && !searchParams.get('fs')
            && !searchParams.get('page')

        useHead({
            meta: [{
                hid: 'robots',
                name: 'robots',
                content: canIndex ? 'index, follow' : 'noindex, nofollow',
            }],
        })
    }

    const updateSeoAfterUrlChange = (event) => {
        updateCanonical()
        updateCategoryFilterRobots(event)
    }

    nuxtApp.hook('page:finish', updateCanonical)
    window.addEventListener('urlReplaced', updateSeoAfterUrlChange)
})
